import React from 'react';
import { ArrowRight, ChevronDown } from 'lucide-react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function HeroSection() {
  const {
    ref,
    isRevealed
  } = useScrollReveal();
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section ref={ref} className="relative min-h-screen flex flex-col justify-center items-center text-center px-4 overflow-hidden pt-20" data-id="element-126">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[radial-gradient(circle,rgba(201,168,76,0.15)_0%,transparent_70%)] pointer-events-none z-0" data-id="element-127" />

      <div className={`relative z-10 max-w-4xl mx-auto transition-all duration-1000 transform ${isRevealed ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-128">
        <div className="inline-block mb-6 px-4 py-1.5 rounded-full border border-[#c9a84c]/30 bg-[#c9a84c]/5 backdrop-blur-sm" data-id="element-129">
          <span className="text-[#c9a84c] text-xs md:text-sm font-medium tracking-[0.2em] uppercase" data-id="element-130">
            Premium Digital Presence
          </span>
        </div>

        <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold tracking-tighter mb-8 text-white" data-id="element-131">
          AI WEBSITE <br data-id="element-132" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#c9a84c] via-[#e6cf8b] to-[#c9a84c] drop-shadow-[0_0_15px_rgba(201,168,76,0.3)]" data-id="element-133">
            PACKAGE
          </span>
        </h1>

        <p className="text-lg md:text-xl text-gray-400 max-w-2xl mx-auto mb-10 leading-relaxed" data-id="element-134">
          Elevate your brand with a cinematic, high-performance website powered
          by next-generation AI. Delivered in 48 hours.
        </p>

        {/* Floating Price Card */}
        <div className="inline-block mb-12 transform hover:-translate-y-1 transition-transform duration-300" data-id="element-135">
          <div className="px-8 py-4 bg-[#0a0a0a] border border-[#c9a84c]/50 rounded-lg shadow-[0_0_30px_-5px_rgba(201,168,76,0.3)]" data-id="element-136">
            <span className="text-3xl font-bold text-white" data-id="element-137">200€</span>
            <span className="ml-2 text-gray-400 text-sm uppercase tracking-wider" data-id="element-138">
              All Included
            </span>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6" data-id="element-139">
          <a href="https://wa.me/660960231920?text=hi%20i%20want%20the%20200%E2%82%AC%20ai%20website%20package.%20please%20send%20me%20the%20next%20steps." target="_blank" rel="noopener noreferrer" className="group relative px-8 py-4 bg-[#c9a84c] text-black font-bold text-sm tracking-widest uppercase rounded overflow-hidden transition-all duration-300 hover:shadow-[0_0_20px_rgba(201,168,76,0.6)]" data-id="element-140">
            <span className="relative z-10 flex items-center" data-id="element-141">
              Get Started Now{' '}
              <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" data-id="element-142" />
            </span>
            <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300" data-id="element-143" />
          </a>

          <button onClick={scrollToPricing} className="px-8 py-4 border border-[#c9a84c]/50 text-[#c9a84c] font-medium text-sm tracking-widest uppercase rounded hover:bg-[#c9a84c]/10 transition-colors duration-300" data-id="element-144">
            View Pricing
          </button>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 animate-bounce text-[#c9a84c]/50" data-id="element-145">
        <ChevronDown className="h-6 w-6" data-id="element-146" />
      </div>
    </section>;
}